var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"mosaico"}},[_c('ul',{staticClass:"mosaico"},_vm._l((_vm.items),function(item,index){return _c('li',{class:`_0${index+1}`},[_c('img',{attrs:{"src":item.image}})])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }